import React from 'react';
import { addElement } from '../../../actions/CreateSiteActions/createSiteActions';
import { connect } from 'react-redux';
import PeoplePicker  from '../../formFields/PeoplePicker';
import { ADD_STEERING_COMMITTEE } from '../../../actions/types';
import InfoTooltip from '../../formFields/InfoTooltip';

class SteeringCommittee extends React.Component {

    _onSelectedUser = (items) => {
        this.props.addSteeCo(items);
    }
    render() {
        
        return (
            <div className='wizard-inside-third' style={{height: 'unset'}}>
                <div className="item-Owner">
                Steering Committee
                    <InfoTooltip content='The Steco will be team administrator and will have access to the “General” and the “Governance” team channels. This configuration can be later changed by any other team administrator, if needed.' />
                </div>
                {/* {warning} */}
                <PeoplePicker
                    defaultUsers= {this.props.steeringCommittee} 
                    onSelectedUsers={this._onSelectedUser} 
                    
                    // errorMessage={error}
                />
            </div>
        );
    }
}

const mapActionToProp = (dispatch) => ({
    addSteeCo: (element) => { dispatch(addElement(ADD_STEERING_COMMITTEE, element)) }
})

const mapStateToProps  = state => ({
    currentUser: state.user.currentUser,
    steeringCommittee: state.newSite.SteeringCommittee,
    possibleWarning : state.wizard.nextStepRequested
})

export default connect(mapStateToProps, mapActionToProp)(SteeringCommittee);







// WEBPACK FOOTER //
// ./src/components/CreateSite/Step5/SteeringCommittee.js